interface ValidationRule {
  field: string;
  value: any;
  message: string;
}

interface ValidationResult {
  isSuccess: boolean;
  message?: string;
  field?: string;
}

// utils/validation.ts
export const validateRequired = (rules: ValidationRule[]): ValidationResult => {
  for (const rule of rules) {
    if (!rule.value || (typeof rule.value === 'string' && !rule.value.trim())) {
      return {
        isSuccess: false,
        message: rule.message,
        field: rule.field
      };
    }
  }

  return {
    isSuccess: true
  };
};

export const isValidValue = (value: any): boolean =>
  value !== undefined && value !== null && value !== '';

export const filterValidEntries = <T extends Record<any, any>, U extends Partial<T>>(obj: T): U =>
  Object.fromEntries(Object.entries(obj).filter(([_, value]) => isValidValue(value))) as U;
